import { useTranslation } from 'react-i18next'

import CoverageLengthImageHu from 'assets/images/fedesi-hossz.png'
import CoverageLengthImageEn from 'assets/images/fedesi-hossz-en.png'

export default function useLocalizedImages() {
  const { i18n } = useTranslation()

  const getStructuralWidthImage = (baseName) => {
    const suffix = i18n.language === 'en' ? '-en' : ''
    return require(`assets/images/structural-width/${baseName}${suffix}.png`)
  }

  const getCoverageLengthImage = (() => i18n.language === 'en' ? CoverageLengthImageEn : CoverageLengthImageHu)

  return {
    CoverageLengthImage: getCoverageLengthImage(),
    getStructuralWidthImage
  }
}
